import ObjectPassportization from './container'

export default ObjectPassportization
